<template>
    <l-layer-group
        :layer-type="overlay.type"
        v-model:visible="overlay_visible"
        :name="(overlay.name)"
        ref="unitZoneItemsLayer"
        @ready="onReady()"
    >
        <l-feature-group
            ref="unitZoneLayer"
            id="unit_zone"
        >
        </l-feature-group>
    </l-layer-group>
</template>
<script>
import {LFeatureGroup, LLayerGroup} from "@vue-leaflet/vue-leaflet";
import {mapGetters, mapActions} from "vuex";
import debounce from "lodash/debounce";
import unitLmsgMixin from "@/mixins/unitLmsgMixin";

export default {
    setup() {
        return {
            debounceUpdate: debounce((fn) => fn(), 400),
        }
    },
    name: "SectionMap_layer_unit_zone",
    emits: ['update:modelValue'],
    mixins: [unitLmsgMixin],
    inject: ['L'],
    props: {
        modelValue: Object,
    },
    components: {
        LFeatureGroup,
        LLayerGroup,
    },
    data() {
        return {
            unitZoneItemsLayer: null,
            unitZoneLayer: null,
        }
    },
    computed: {
        ...mapGetters([
        ]),
        overlay() {
            return this.modelValue
        },
        overlay_visible: {
            get() {
                return this.overlay?.visible
            },
            set(vl) {
                this.$emit('update:modelValue', {...this.overlay, visible: vl})
            },
        },
        isShowLayer() {
            return this.overlay?.showLayer
        },
        unitId() {
            return this.isShowLayer ? this.routeFilter.unitId : null
        },
        signalRadius() {
            let radius = this.unit?.signal_radius || 0
            switch (this.unit?.hw_type) {
                case 'm2m': {
                    radius = this.unitLmsg?.sensors?.radius?.value || 0
                }
            }
            if(this.unit?.type == 'ble_gateway') {
                radius = radius || 200
            }
            return radius;
        },
        handlerGeozone() {
            return [this.unitId, this.unitLmsgLatLng?.lat, this.unitLmsgLatLng?.lng, this.signalRadius].join('|')
        },
    },
    watch: {
        handlerGeozone: {
            handler: function () {
                this.debounceUpdate(() => this.updateGeozone())
            },
            immediate: true,
        }
    },
    methods: {
        ...mapActions([
        ]),
        modalClose() {
            this.modalWindows = {}
        },
        _unitIcon(){
            return false;
        },
        onReady() {
            if(this.$isDevelopment) console.log('ready')
            this.unitZoneLayer = this.$refs.unitZoneLayer.leafletObject
            this.unitZoneItemsLayer = this.$refs.unitZoneItemsLayer.leafletObject
        },
        updateGeozone() {
            this.unitZoneLayer.clearLayers()
            if(!this.unitLmsgLatLng?.lat && !this.unitLmsgLatLng?.lng) return false;
            let geo = this.L.circle(
                this.unitLmsgLatLng,
                {
                    radius: this.signalRadius,
                    meta: {},
                    color: '#066DE6',
                    fillColor: '#066DE6',
                    fillOpacity: 0.5
                }
            )
            this.unitZoneLayer.addLayer(geo)
        }
    },
    created() {
    },
    mounted() {
    },
    updated() {
        if(this.$isDevelopment) console.log('updated', this._.type.name)
    },
    beforeUnmount() {
    }
}
</script>

<style scoped>

</style>